export const FEDOPS_APP_NAME = 'communities-blog-custom-feed-widget';



// WEBPACK FOOTER //
// ./rss-feed-widget/constants/fedops.js